import React, { createContext, useContext, useState } from 'react';

const AuthDataContext = createContext();

export const useAuthData = () => {
    const context = useContext(AuthDataContext);
    if (!context) {
        throw new Error('useAuthData must be used within an AuthDataProvider');
    }
    return context;
};

export const AuthDataProvider = ({ children }) => {
    const [authData, setAuthData] = useState({
        phoneNumber: '',
        firstName: '',
        birthDate: null,
        gender: '',
        interestedIn: '',
        lookingFor: '',
        pictures: []
    });

    const updateAuthData = (newData) => {
        setAuthData(prevData => ({
            ...prevData,
            ...newData
        }));
    };

    return (
        <AuthDataContext.Provider value={{ authData, updateAuthData }}>
            {children}
        </AuthDataContext.Provider>
    );
};
